import React, { Fragment, useContext } from 'react';
import {styled, useTheme} from '@mui/material/styles';
import Collapsible from 'react-collapsible';

import Videoplayer from "./Videoplayer/";
import Imageslider from "./Imageslider";
import ImagesliderAdvanced from "./ImagesliderAdvanced";
import InlinePlayer from "./InlinePlayer";

import Imageplayer from "./Imageplayer";
import Text from "./Text";
import ThreeSixtyViewer from "./ThreeSixtyViewer";
import Map from "./Map.js";
import Comparisonslider from './Comparisonslider';
import CrowdsignalPoll from './CrowdsignalPoll';
import IndoorMap from "./IndoorMap";

//css loaded here vs in components to avoid dups
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "../css/collapsible.css";
import "../css/richtext.css";
import {SearchBox} from "./SearchBox/SearchBox";
import {NextLinks} from "./NextLinks/nextLinks";

import { useAllFiles } from '../hooks/all-files';

const PREFIX = 'ComponentsWrapper';

const classes = {
    padding: `${PREFIX}-padding`,
};

const Root = styled('div')((
    {
        theme
}
) => ({
    [`& .${classes.padding}`]: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    [`& .${classes.padding} .richtext`]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    }
}));

const ComponentsWrapper = (props) => {
    const { entity } = props;
    const theme = useTheme();

    const componentProps = { files: useAllFiles() };
    let componentPositionExcludingTopBar = -1;

    return (
        <Root className={theme.palette.mode}>{
            entity.Components.map((component, n) => {
                const Wrap = component.collapsible ?
                    ({ children, component }) =>
                        <Collapsible trigger={component.label || 'Click here'} open={!component.collapsed}>
                            {children}
                        </Collapsible>
                    :
                    ({children}) => <>{children}</>
                componentPositionExcludingTopBar++;

                return <Fragment key={`${component.strapi_component}${n}`}>
                    <NextLinks relations={entity.Relations} originalLocale={entity.locale} defaultLocale={props.defaultLocale} onlyRenderIfMatchesPosition={componentPositionExcludingTopBar}/>
                    <Wrap component={component}>{(() => {
                    switch (component.strapi_component) {
                        case 'component.videoplayer':
                            return <Videoplayer component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.imageslider':
                            return <Imageslider component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.imageslider-advanced':
                            return <ImagesliderAdvanced component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.inlineplayer':
                            return <div className={classes.padding} >
                                <InlinePlayer component={component} entity={entity} {...props} {...componentProps} />
                            </div>
                        case 'component.imageplayer':
                            return <Imageplayer component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.text':
                            return <div className={classes.padding} ><Text component={component} entity={entity} {...props} {...componentProps} /></div>
                        case 'component.three-sixty-viewer':
                            return <ThreeSixtyViewer component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.map':
                            return <Map component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.comparisonslider':
                            return <Comparisonslider component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.crowdsignal-poll':
                            return <CrowdsignalPoll component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.indoor-map':
                            return <IndoorMap component={component} entity={entity} {...props} {...componentProps} />
                        case 'component.search':
                            return <SearchBox component={component} entity={entity} {...props} {...componentProps} />
                        default:
                            componentPositionExcludingTopBar--;
                            return <></>;
                    }
                })()}
                </Wrap>
                </Fragment>
            })
        }
            <NextLinks relations={entity.Relations} originalLocale={entity.locale} defaultLocale={props.defaultLocale} onlyRenderIfMatchesPosition={'afterComponents'}/>
        </Root>
    );
}

export default ComponentsWrapper
